import styles from "../styles/profile.module.scss";
import Button from "../../../components/shared/Button/Button";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/routes";
import { setOpenModal } from "../../../store/slices/modals.slice";
import { useDispatch } from "react-redux";

const SuccessRemoveSubscriptionModal = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div className={styles.subscriptionModalWrapper}>
      <div className={styles.removeSubModalTextContent}>
        <div className={styles.removeSubModalTitle}>{t("subRemovedTitle")}</div>
        <div className={styles.removeSubModalDescr}>{t("subRemovedDescr")}</div>
      </div>

      <Button
        title={t("chooseSub")}
        submit={() => {
          dispatch(setOpenModal(""));
          navigate(ROUTES.DISCOUNT);
        }}
        className={styles.confirm}
      />
    </div>
  );
};

export default SuccessRemoveSubscriptionModal;
